export default "__VITE_ASSET__BFWG22z7__"